/**
 * Point d’entrée du widget embarquable (script à coller sur un site tiers).
 * Lit data-token et optionnellement data-api-url sur la balise <script>.
 * Crée un conteneur et monte le ChatWidget React.
 * Les styles du panneau de chat sont injectés par styled-components dans le JS.
 * Le fichier widget.css (généré depuis widget-embed.css) sert au reset du conteneur #crispclone-widget-root.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setWidgetApiBaseUrl } from './api/widget';
import ChatWidget from './widget/ChatWidget';
import './widget-embed.css';

const script = document.currentScript as HTMLScriptElement | null;
const token = script?.getAttribute('data-token')?.trim();
const apiUrl = script?.getAttribute('data-api-url')?.trim();

if (!token) {
  console.warn('[CrispClone Widget] data-token manquant sur la balise script.');
} else {
  if (apiUrl) {
    setWidgetApiBaseUrl(apiUrl);
  }

  const rootId = 'crispclone-widget-root';
  let rootEl = document.getElementById(rootId);
  if (!rootEl) {
    rootEl = document.createElement('div');
    rootEl.id = rootId;
    document.body.appendChild(rootEl);
  }

  createRoot(rootEl).render(
    <StrictMode>
      <ChatWidget siteToken={token} />
    </StrictMode>
  );
}
